<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-form ref="query" :model="query" inline>
        <el-form-item prop="fDistributorID" label="经销商">
          <el-select-table
            v-model="query.fDistributorID"
            :label.sync="fNumber"
            search-key="name"
            url="BasicInformation/Distributor/DistributorChoiceEntry"
            label-field="fName"
            value-field="fid"
            size="small"
            :extra-param="{prohibit:false}"
            panel-width="500px"
            :columns="[
              { prop: 'fNumber', label: '编码' },
              { prop: 'fName', label: '名称' },

            ]"
          />
        </el-form-item>

        <el-form-item prop="startDate" label="审核日期">
          <el-date-picker
            v-model="query.startDate"
            type="date"
            placeholder="选择日期"
            size="small"
            style="width: 150px"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item prop="endDate" label="至">
          <el-date-picker
            v-model="query.endDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            style="width: 150px"
            size="small"
          />
        </el-form-item>
      </el-form>

      <el-button
        type="primary"
        size="small"
        style="margin-right: 10px"
        @click="refresh"
      >查询</el-button>
      <el-button-export
        v-if="candown"
        :url="downloadUrl"
        type="primary"
        size="small"
        style=""
      >下载报表</el-button-export>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
      >
        <el-table-column prop="fDistributorNumber" label="充值账户" />
        <el-table-column prop="fDistributor" label="经销商" />
        <el-table-column prop="fCreateTime" label="单据日期" />
        <el-table-column prop="fCheckDate" label="审核日期" />
        <el-table-column prop="fBillNo" label="充值单号" />
        <el-table-column prop="fPay" label="单位名称" />
        <el-table-column prop="fMoney_jk" label="代扣金额/借款" />
        <el-table-column prop="fMoney_zz" label="收入转账" />
        <el-table-column prop="total" label="合计" />
      </el-table>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  data() {
    return {
      query: {
        fDistributorID: null,

        startDate: null,
        endDate: null
      },
      fNumber: '',
      stockList: [],
      ICItemList: [],
      tableData: [],
      loading: false,
      currentEditItem: null,
      candown: true
    }
  },
  mounted() {
    const newtime = moment(new Date()).format('YYYY-MM-DD')
    this.query.startDate = newtime
    this.query.endDate = newtime
    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == '006004002') {
        this.candown = val.isGrant
      }
    })
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost('Report/RechargeReport', this.query)
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }
          this.tableData = res.datalist
          this.pageRecordTotal = res.datalist.total
        })
        .finally(() => (this.loading = false))
    },

    downloadUrl: function() {
      const req = this.query
      return this.$buildDownloadUrl(
        'LogisticsSystemApi/Report/RechargeReportDownload',
        { ...req }
      )
    }
  }
}
</script>
<style scoped lang='less'>
.query-bar {
}
</style>
